<!-- TEMPLATE -->
<template>
    <div :class='contactsListClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
                  <span slot='title'>
                    <span class='avenir-heavy'>{{title}}</span>
                  </span>
                  <dean-section-title-item
                    v-if="!showArchive"
                    :icon='archiveIcon'
                    :content="true"
                    @click.native="sectionRoute('partners.contacts.list.status', {status: 'verwijderd'})"
                  >
                    archief
                  </dean-section-title-item>
                  <dean-section-title-item
                    v-else
                    :icon='returnIcon'
                    :content="true"
                    @click.native="sectionRoute('partners.contacts.list')"
                  >
                    Terug naar actief
                  </dean-section-title-item>
                  <dean-section-title-item
                    v-if="canCreateContact()"
                    :icon='plusIcon'
                    :content="true"
                    @click.native="sectionRoute('partner.contact.add', {pid: $route.params.pid})"
                  >
                    Nieuw
                  </dean-section-title-item>
                </dean-section-title>

                <dean-table
                  :data='contactsData'
                  :columns='columns'
                  :hover="true"
                  @column-click='columnClick'
                  @cell-click="cellClick"
                >
                </dean-table>

                <dean-pagination
                  :current-page='contactsMetaData.pageNumber'
                  :total-items='contactsMetaData.totalResults'
                  :items-per-page='contactsMetaData.itemsPerPage'
                  :select-items-per-page='selectItemsPerPage'
                  :visible-pages='contactsMetaData.visiblePages'
                  @page-changed='paginationChanged'
                  @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';

  import {
    // SVG
    invoicesIcon,
    archiveIcon,
    returnIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;

    // COMPUTED
    get contactsListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get contactsMetaData() {
      return this.pageMeta;
    }

    get contactsData() {
      return this.data;
    }

    get title() {
      return this.showArchive ? 'Verwijderde contacten' : 'Contacten';
    }

    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      receivesInvoices: {
        content: 'ontvangt facturen',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      receivesNotifications: {
        content: 'ontvangt berichten',
        align: 'left',
        sort: true,
        dql: 'name',
      },
    };

    public tableName(): string {
      return 'partner-contacts';
    }

    public cellClick(target: { cell: object, row: { id: string, organizationId: string }, column: string }) {
      this.$router.push({
        name: 'partner.contact.edit',
        params: {contactId: target.row.id, pid: target.row.organizationId},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const requestUrl: string = '/-/trade/api/partner.contacts.list';

      const requestData: any = {
        id: this.$route.params.pid,
        isUser: false,
        deleted: data.showArchive ? true : null,
      };

      axios.post(requestUrl, requestData)
        .then((response) => {
          const partnerContactsData: any[] = [];
          for (const item of response.data.data) {
            const row = {
              id: item.id,
              organizationId: item.organizationId,
              name: item.name,
              receivesInvoices: item.receivesInvoices ? 'Ja' : 'Nee',
              receivesNotifications: item.receivesNotifications ? 'Ja' : 'Nee',
            };
            partnerContactsData.push(row);
          }

          this.data = partnerContactsData;
          this.updateMeta(response.data.meta);
        }).then(
        // Resolve promise response/error
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateContact(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-contact')) {
        return true;
      }

      return false;
    }

    public created() {
      this.showArchive = this.$router.currentRoute.params.status === 'verwijderd';

      const data: any = this.pageMeta;
      data.showArchive = this.showArchive;

      this.setDefaultSort('name');
      this.loadList(data);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>

